"use client";

import { useState } from "react";
import { usePathname } from 'next/navigation'
import styles from "./styles.module.scss";
import CopyLinkLogo from "/public/_a/icons/socialMedia/copylink.svg";
import FBLogo from "/public/_a/icons/socialMedia/fb.svg";
import XLogo from "/public/_a/icons/socialMedia/X.svg";
import LinkedInLogo from "/public/_a/icons/socialMedia/linkedIn.svg";
import WhatsAppLogo from "/public/_a/icons/socialMedia/whatsapp.svg";
import Image from "next/image";
import cn from "clsx";

export default function SocialMediaSection({heading, date}) {
  const [copySuccess, setCopySuccess] = useState("");
  const pathname=usePathname();


  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopySuccess("Link copied!");
    } catch (err) {
      setCopySuccess("Failed to copy text");
    } finally {
      setTimeout(() => {
        setCopySuccess("");
      }, 2000);
    }
  };

  const fireWebEngage = (source:any) => {
    window.webengage.track("Share Blog",{
      "Blog Title":heading,
      "Read Time": date,
      "Shared On": source
    })
  }

  return (
    <div className={styles.socialMediaContainer}>
      <span className={styles.title}>Share : </span>
      <div className="relative">
        <Image
          src={CopyLinkLogo}
          alt="Copy Link"
          className={styles.copyLinkLogo}
          onClick={copyToClipboard}
        />
        {copySuccess && (
          <div onClick={()=>fireWebEngage("Copy-Link")}  className={cn(styles.tooltip, {
              [styles.show]: !!copySuccess,
            })}
          >
            {copySuccess}
          </div>
        )}
      </div>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          window?.location?.href
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={()=>fireWebEngage("Facebook")} 
      >
        <Image src={FBLogo} alt="Facebook" />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          window?.location?.href
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={()=>fireWebEngage("X")} 
      >
        <Image src={XLogo} alt="X" />
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          window?.location?.href
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={()=>fireWebEngage("LinkedIn")} 
      >
        <Image src={LinkedInLogo} alt="LinkedIn" />
      </a>
      <a
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
          window?.location?.href
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={()=>fireWebEngage("Whatsapp")} 
      >
        <Image src={WhatsAppLogo} alt="Whatsapp" />
      </a>
      <a
         href={`${
          window?.location?.origin+'/rss'+pathname
        }`}
        rel="noopener noreferrer"
        onClick={()=>fireWebEngage("RSS")} 
      >
      </a>
    </div>
  );
}
